import React from 'react';
import { Icon } from '../../lib/icons';

// PAELBI logo lockup (linear house + leaf sprig, drawn with strokes).
export function PaelbiLogo({ compact = false, className = '' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <span className="relative inline-flex h-9 w-9 items-center justify-center">
        <svg viewBox="0 0 40 40" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M8 18 L20 8 L32 18 V33 H8 Z" className="text-paelbi-brown" />
          <path d="M24 8 C27 4 31 4 33 6 C31 10 27 11 24 10" className="text-paelbi-brown" />
          <path d="M27 7 L24 12" className="text-paelbi-brown" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg tracking-[0.25em] text-paelbi-ink">PAELBI</span>
        {!compact && (
          <span className="mt-0.5 font-sans text-[9px] font-semibold uppercase tracking-[0.3em] text-paelbi-ink/60">Il tuo B&amp;B</span>
        )}
      </span>
    </div>
  );
}

export function DomiraLogo({ className = '' }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <span className="relative inline-flex h-9 w-9 items-center justify-center">
        <svg viewBox="0 0 40 40" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M8 18 L20 8 L32 18 V33 H8 Z" className="text-paelbi-ink" />
          <path d="M24 8 C27 4 31 4 33 6 C31 10 27 11 24 10" className="text-paelbi-ink" />
          <path d="M27 7 L24 12" className="text-paelbi-ink" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-display text-lg tracking-[0.22em] text-paelbi-ink">DOMIRA</span>
        <span className="mt-0.5 font-sans text-[9px] font-semibold uppercase tracking-[0.35em] text-paelbi-ink/60">Solutions</span>
      </span>
    </div>
  );
}

export { Icon };
